import dynamic from 'next/dynamic';
import { Text, useMediaQuery } from '@sparknz/spark-pattern-library';

import { useProductDetails } from 'journey/productDetails/provider';
import { useSegment } from 'shared/hooks';
import CapacityOptions from '../CapacityOptions';
import ColorOptions from '../ColorOptions';
import DeliveryOptionsSection from '../DeliveryOptionsSection';

const DynamicProductOrderConfigurator = dynamic(
  () => import('./components/ProductOrderConfigurator'),
  {
    ssr: false,
  },
);

export default function Configurator() {
  const isMobileView = useMediaQuery({ max: 'lil' });
  const {
    selectedDevice: {
      description,
      groupName,
      primaryCategory,
      richTextContent,
    },
  } = useProductDetails();
  const { isLargeBusiness } = useSegment();

  return (
    <>
      <Text variant="headingM" mb={['s2', 's3']}>
        {groupName}
      </Text>
      {!richTextContent ? (
        <Text variant="bodyMDemi" mb={['s3', 's4', 's8']}>
          {description}
        </Text>
      ) : null}
      {isMobileView ? null : <ColorOptions />}
      <CapacityOptions />
      {isLargeBusiness ? null : <DeliveryOptionsSection />}
      <DynamicProductOrderConfigurator primaryCategory={primaryCategory} />
    </>
  );
}
